module.exports = __webpack_public_path__ + "static/media/register-property-bungalow-semiD.107c61f3.png";